/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { UserRole } from "~/models";
import { ACTIONS } from "./actions";

export const rules = {
  [UserRole.STANDARD_USER]: {
    static: [
      ACTIONS.ADD_SERVICE_SLA,
      ACTIONS.ADD_SERVICE_VERSION,
      ACTIONS.ADD_SERVICE_GROUP_SLA,
      ACTIONS.ADD_CUSTOMER,
      ACTIONS.ADD_CUSTOMER_CONTRACT,
      ACTIONS.ADD_CUSTOMER_PRODUCT,
      ACTIONS.ADD_CUSTOMER_EMPLOYEE,
      ACTIONS.ADD_CUSTOMER_CONTACT,
      ACTIONS.ADD_CUSTOMER_REQUEST,
      ACTIONS.ADD_CUSTOMER_ASSIGNMENT,
      ACTIONS.ADD_ASSIGNMENT_SERVICE,
      ACTIONS.ADD_APPLICATION_SERVICE,
      ACTIONS.ADD_APPLICATION,
      ACTIONS.ADD_ENVIRONMENT,
      ACTIONS.DELETE_CUSTOMER,
      ACTIONS.EDIT_ROLES,
      ACTIONS.EDIT_CONTACT_TYPES,
      ACTIONS.EDIT_APPLICATION,
      ACTIONS.DELETE_CUSTOMER_CONTRACT,
      ACTIONS.DELETE_CUSTOMER_ASSIGNMENT,
    ],
  },
  [UserRole.BASIC_USER]: {
    static: [],
  },
};
